import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react'
import { ComponentProps, FC } from 'react'

import { useLogEvent } from 'lib/postHog/useLogEvent'

export const ERROR_SCREEN_SHOWN_EVENT = 'error_screen_shown'

type ErrorBoundaryProps = ComponentProps<typeof SentryErrorBoundary> & {
  /**
   * Identifies the boundary in the `error_screen_shown` PostHog event,
   * sent as the `component` metadata property.
   */
  name: string
}

/**
 * Drop-in replacement for the `@sentry/react` ErrorBoundary that also logs
 * an `error_screen_shown` event to PostHog when the fallback is displayed.
 */
export const ErrorBoundary: FC<ErrorBoundaryProps> = ({
  name,
  onError,
  ...sentryProps
}) => {
  const { logEvent } = useLogEvent()

  return (
    <SentryErrorBoundary
      {...sentryProps}
      onError={(...args) => {
        logEvent({
          eventName: ERROR_SCREEN_SHOWN_EVENT,
          metadata: { component: name }
        })
        onError?.(...args)
      }}
    />
  )
}
